module.exports = __webpack_public_path__ + "img/ico_extrato-financeiro.1a94b766.svg";